<template>
  <banners-form
    :form="form"
    :tabs="tabs"
    @change="handleImage"
    @submit="submitForm"
    @delete="deleteAction"
  />
</template>

<script>
import bannersMixin from "@/components/banners/banners-mixin"
export default {
  mixins: [bannersMixin]
}
</script>
